import { PlanJour } from "./plan-jour.model";
import { PlanSemaine } from "./plan-semaine.model";

export class PlanMois {
    constructor(anneeMois: string) {
        this.anneeMois = anneeMois;
    }

    public anneeMois: string;
    public listeSemaines: PlanSemaine[] = [];

    get listeJours(): PlanJour[] {
        let listeJours: PlanJour[] = [];
        for (const curSemaine of this.listeSemaines) {
            listeJours = [...listeJours, ...curSemaine.listeJours];
        }
        return listeJours;
    }
}
